export default "__VITE_ASSET__DN4ESyto__"